module.exports = __webpack_public_path__ + "static/media/BSNALogoCircle.c4f97b32.png";